<template>
  <admin-card title="Редактирование курса" v-if="course">
    <form @submit.prevent="" @keydown="form.onKeydown($event)">
      <!-- Course Title -->
      <div class="form-group row">
        <label class="col-md-3 col-form-label text-md-right">Название курса</label>
        <div class="col-md-7">
          <input v-model="form.title" type="text" name="title" class="form-control"
                 @change="update()"
                 :class="{ 'is-invalid': form.errors.has('title') }">
          <has-error :form="form" field="title"></has-error>
        </div>
      </div>

      <!-- About course -->
      <div class="form-group row">
        <label class="col-md-3 col-form-label text-md-right">О курсе</label>
        <div class="col-md-7">
          <input v-model="form.about" type="text" name="about" class="form-control"
                 @change="update()"
                 :class="{ 'is-invalid': form.errors.has('about') }">
          <has-error :form="form" field="about"></has-error>
        </div>
      </div>

      <!-- Lessons counter string -->
      <div class="form-group row">
        <label class="col-md-3 col-form-label text-md-right">Количество занятий</label>
        <div class="col-md-7">
          <input v-model="form.lessons_counter" type="text" name="about" class="form-control"
                 @change="update()"
                 :class="{ 'is-invalid': form.errors.has('lessons_counter') }">
          <has-error :form="form" field="lessons_counter"></has-error>
        </div>
      </div>

      <!-- Course Image -->
      <div class="form-group row">
        <label class="col-md-3 col-form-label text-md-right">Основное изображение курса</label>

        <div class="col-md-3">
          <picture-input

            ref="pictureInput"
            @change="imageSelected('image')"
            width="200"
            height="200"
            margin="0"
            accept="image/jpeg,image/png,image/svg"
            size="10"
            buttonClass="btn"
            :customStrings="{
                drag: 'Drag an image here'
              }">
          </picture-input>
          <has-error :form="form" field="image"></has-error>
        </div>
        <div class="col-md-3"  v-if="form.image">
          <img style="max-width:100%;" v-bind:src="'/images/courses/' + course.id + '/' + form.image" />
          <button class="btn btn-warning" @click.prevent="removeImage('image')">Удалить изображение</button>
        </div>
      </div>

      <!-- Scores -->
      <div class="form-group row">
        <label class="col-md-3 col-form-label text-md-right">Баллы за прохождение</label>
        <div class="col-md-7">
          <input v-model="form.scores" type="number" name="scores" class="form-control"
                 @change="update()"
                 :class="{ 'is-invalid': form.errors.has('scores') }">
          <has-error :form="form" field="scores"></has-error>
        </div>
      </div>



      <!-- Course Image -->
      <div class="form-group row">
        <label class="col-md-3 col-form-label text-md-right">Логотип партнёра</label>

        <div class="col-md-3">
          <picture-input

            ref="pictureInputPartnerLogo"
            @change="partnerLogoSelected()"
            width="200"
            height="200"
            margin="0"
            accept="image/jpeg,image/png,image/svg"
            size="10"
            buttonClass="btn"
            :customStrings="{
                drag: 'Drag an image here'
              }">
          </picture-input>
          <has-error :form="form" field="partner_logo"></has-error>
        </div>
        <div class="col-md-3"  v-if="form.partner_logo">
          <img style="max-width:100%;" v-bind:src="'/images/courses/' + course.id + '/' + form.partner_logo" />
          <button class="btn btn-warning" @click.prevent="removeImage('partner_logo')">{{ $t('remove_image') }}</button>
        </div>
      </div>

      <!-- Course author -->
      <div class="form-group row" v-if="!isTeacher">
        <label class="col-md-3 col-form-label text-md-right">Автор курса</label>
        <div class="col-md-7">
          <select v-model="form.author_id"
                  class="form-control"
                  name="author_id"
                  @change="update()"
                  :class="{ 'is-invalid': form.errors.has('author_id') }">
            <option v-for="user in users" v-bind:value="user.id">
              {{ user.name }}
            </option>
          </select>
          <has-error :form="form" field="author_id"></has-error>
        </div>
      </div>

      <!-- Course teacher -->
      <div class="form-group row" v-if="!isTeacher">
        <label class="col-md-3 col-form-label text-md-right">Преподаватель на курсе</label>
        <div class="col-md-7">
          <select v-model="form.teacher_id"
                  class="form-control"
                  name="teacher_id"
                  @change="update()"
                  :class="{ 'is-invalid': form.errors.has('teacher_id') }">
            <option v-for="user in users" v-bind:value="user.id">
              {{ user.name }}
            </option>
          </select>
          <has-error :form="form" field="teacher_id"></has-error>
        </div>
      </div>

      <!-- Course is hidden -->
      <div class="form-group row">
        <div class="col-md-7 col-md-offset-3">
          <div class="form-check">
            <label class="form-check-label">
              <input type="checkbox"
                     class="form-check-input"
                     name="hidden"
                     @change="update()"
                     v-model="form.hidden">
              Скрытый курса
            </label>
            <has-error :form="form" field="hidden"></has-error>
          </div>
        </div>
      </div>

      <!-- Course is official_course -->
      <div class="form-group row">
        <div class="col-md-7 col-md-offset-3">
          <div class="form-check">
            <label class="form-check-label">
              <input type="checkbox"
                     class="form-check-input"
                     name="official_course"
                     @change="update()"
                     v-model="form.official_course">
              Официальный курс ШПМ
            </label>
            <has-error :form="form" field="official_course"></has-error>
          </div>
        </div>
      </div>

      <!-- Course description -->
      <div class="form-group row">
        <label class="col-md-12 col-form-label text-md-left">Описание курса</label>
        <div class="col-md-12">
          <content-editor @change="update()" v-model="form.description" :options="options" :controls="true"></content-editor>
          <has-error :form="form" field="description"></has-error>
        </div>
      </div>

      <!-- Submit Button -->
      <div class="form-group row">
        <div class="col-md-9 ml-md-auto">
          <button @click.prevent="update()" type="button" class="btn btn-default">Сохранить</button>
        </div>
      </div>
    </form>

    <h2>Занятия курса</h2>

    <table class="table table-striped table-bordered admin-table">
      <thead>
      <tr>
        <th colspan="3" class="admin-table__controls">
          <router-link :to="{ name: 'admin.lesson.add', params: { courseId : course.id }}"
                       class="btn btn-primary"
                       active-class="active">
            Создать
          </router-link>
        </th>
      </tr>
      <tr>
        <th>ID</th>
        <th>Название</th>
        <th>Управление</th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="lesson in lessons">
        <td>{{ lesson.id }}</td>
        <td>{{ lesson.title }}</td>
        <!--<td>{{ lesson.scores }}</td>-->
        <td>
          <router-link :to="{ name: 'admin.lesson.edit', params: {courseId : course.id, id: lesson.id} }"
                       class="btn btn-primary"
                       active-class="active">
            Редактировать
          </router-link>
          <button class="btn btn-warning" @click.prevent="removeLesson(lesson)">Удалить</button>
        </td>
      </tr>
      </tbody>
      <tfoot>
      <tr>
        <th colspan="4" class="admin-table__controls">
          <router-link :to="{ name: 'admin.lesson.add', params: { courseId : course.id }}"
                       class="btn btn-primary"
                       active-class="active">
            Создать
          </router-link>
        </th>
      </tr>
      </tfoot>
    </table>
  </admin-card>

</template>

<script>
  import { mapGetters } from 'vuex'
  import { Form } from 'vform'
  import AdminPage from '../admin-page';

  export default {
    metaInfo () {
      return { title: 'Создание нового курса' }
    },
    extends: AdminPage,
    components: {
    },
    data: () => ({
      form: new Form({
        id: 0,
        title: '',
        about: '',
        lessons_counter: '',
        scores: '',
        description: '[]',
        author_id: '',
        teacher_id: '',
        image: '',
        background_image: '',
        preview: '',
        hidden: false,
        background_repeat: false,
        official_course: false,
        partner_logo: ''
      }),
      options: {
        postImageUrl: '',
        postFileUrl: '',
        baseImagePath: '',
        baseFilePath: '',
      },
    }),
    computed: mapGetters({
      users: 'users/users',
      isTeacher: 'auth/isTeacher',
      course: 'courses/course',
      lessons: 'lessons/lessons'
    }),
    methods: {
      getImagePath (imageName) {
        return '/images/courses/' + imageName;
      },

      async removeImage (field) {
        const path = '/api/courses/' + this.course.id + '/images';

        const specialForm = new Form({
          image_name: this.form[field]
        });

        await specialForm.delete(path);

        this.form[field] = '';

        this.update();
      },

      async imageSelected (field) {
        const path = '/api/courses/' + this.course.id + '/images';

        const specialForm = new Form({
          image: this.$refs.pictureInput.file,
          old_image_name: ''
        });

        if (this.form.image) {
          specialForm['old_image_name'] = this.form.image;
        }

        const { data } = await specialForm.post(path);
        this.form[field] = data;

        this.update();
      },

      async partnerLogoSelected () {
        const path = '/api/courses/' + this.course.id + '/images';

        const specialForm = new Form({
          image: this.$refs.pictureInputPartnerLogo.file,
          old_image_name: ''
        });

        if (this.form.partner_logo) {
          specialForm['old_image_name'] = this.form.partner_logo;
        }

        const { data } = await specialForm.post(path);
        this.form.partner_logo = data;

        this.update();
      },

      async removeLesson (lesson) {
        if (confirm('Вы уверены, что хотите удалить урок "' + lesson.title + '"?')) {
          await this.$store.dispatch('lessons/remove', {
            courseId: this.course.id,
            lessonId: lesson.id
          });
        }
      },
      async update () {
        console.log('test');
        console.log(this.form);
        await this.$store.dispatch('courses/update', this.form);
        this.$alertify.success(this.$t('admin.global.labels.alert-success'));
      }
    },
    mounted () {
    },
    async beforeMount () {
      const courseId = this.$route.params.id;

      this.options.postImageUrl = '/api/courses/' + courseId + '/images';
      this.options.postFileUrl = '/api/courses/' + courseId + '/files';
      this.options.baseImagePath = '/images/courses/' + courseId;
      this.options.baseFilePath = '/files/courses/' + courseId;

      this.$store.dispatch('users/fetchAll');
      this.$store.dispatch('lessons/fetchAll', courseId);

      this.$store.dispatch('courses/find', courseId).then(response => {
        const courseData = this.course.data;
        this.form.keys().forEach(key => {
          this.form[key] = courseData[key];
        });

        console.log(this.form);
      });
    }
  }
</script>
